import React, { useEffect, useRef, useState } from 'react'
import AgGridTable from 'src/components/AgGridTable'
import { getColorCellValid } from 'src/util/functions';

const columnDef = [
  {headerName: 'Jerarquia', field: "jerarquia", resizable: true, sortable: true, filter: false, width: 50},
  {headerName: 'Estado', field: "estado", resizable: true, sortable: true, filter: true, width: 100},
  {headerName: 'Fila', field: "fila", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Error', field: "error", resizable: true, sortable: true, filter: true, width: 80, hide: true},
]

const TableExcel = ({properties}) => {
  
  const { procesados, noprocesados } = properties;

  const tableRef = useRef(null);
  const validoRef = useRef(null);
  const errorRef = useRef(null);
  const [dataRow, setDataRow] = useState(procesados.concat(noprocesados));

  useEffect(() => {
    validoRef.current.innerHTML = procesados.length;
    errorRef.current.innerHTML = noprocesados.length;
  }, [])
  
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className='d-flex align-items-center justify-content-sm-around w-25'>
          <div>
            <strong style={{fontSize: 20}}>Validos: </strong>
            <span ref={validoRef} style={{fontSize: 20, color: '#64DF38', fontWeight: 'bold'}}> 0</span>
          </div>
          <div>
            <strong style={{fontSize: 20}}>Errores: </strong>
            <span ref={errorRef} style={{fontSize: 20, color: 'red', fontWeight: 'bold'}}> 0</span>
          </div>
        </div>
      </div>
      <div >
        <AgGridTable
          referencia={tableRef}
          columnDef={columnDef}
          dataList={dataRow || []}
          rowSelection={'single'}
          getRowStyle={getColorCellValid}
        /> 
      </div>
    </div>
  )
}

export default TableExcel